@if (!isWidget) {
  <footer [class.ncesi-cart-footer]="isNCESICart">
    @if (!isCheckoutPage) {
      <app-footer-disclaimer></app-footer-disclaimer>
    }
    <!-- END DISCLAIMER TEXT -->
    <!-- START QUESTIONS -->
    @if (!isCheckoutPage) {
      <app-footer-questions></app-footer-questions>
    }
    <!-- END QUESTIONS -->
    <!-- START CONTACT US -->
    @if (!isCheckoutPage) {
      <app-footer-contact-us></app-footer-contact-us>
    }
    <!-- END CONTACT US -->
    <!-- START CHECKOUT FOOTER -->
    @if (isCheckoutPage) {
      <app-footer-checkout></app-footer-checkout>
    }
    <!-- END CHECKOUT FOOTER -->
  </footer>
}
